'use strict'

function installImageProtection (root) {
  if (!root || typeof root.addEventListener !== 'function') return () => {}

  const preventDefault = event => event.preventDefault()
  let installed = true

  root.addEventListener('contextmenu', preventDefault, true)
  root.addEventListener('dragstart', preventDefault, true)

  return () => {
    if (!installed) return
    installed = false
    root.removeEventListener('contextmenu', preventDefault, true)
    root.removeEventListener('dragstart', preventDefault, true)
  }
}

module.exports = { installImageProtection }



// WEBPACK FOOTER //
// ./src/lib/imageProtection.js